<template>
    <div>
        <section class="jumbotron text-center">
            <h1>Event details</h1>
            <p class="lead text-muted" v-if="name">{{name.value}}</p>
            <p class="lead text-muted" v-if="name && name.i18">
                <b-row>
                    <template v-for="l of event.languages">
                        <b-col cols="2" v-if="name.i18[l.substring(0, 2)]" v-bind:key="l">
                            <small>
                                <b>{{l}}</b>
                                <br />
                                <em>{{name.i18[l.substring(0, 2)]}}</em>
                            </small>
                        </b-col>
                    </template>
                </b-row>
            </p>
        </section>
        <i v-if="event.languages &amp;&amp; event.languages.length &gt; 1" class="fa fa-globe"></i>
        <span v-for="l in event.languages">{{l}} </span>
        <br />
        <section>
            <b-card-group columns>
                <b-card v-if="event.organizer_details">
                    <h4>
                        Organizer
                        <b-badge style="float: right">
                            <i class="fa fa-user-circle"></i>
                        </b-badge>
                        
                    </h4>
                    {{event.organizer_details.name}}<br />
                    {{event.organizer_details.contact_person}}<br />
                    {{event.organizer_details.email}}<br />
                    {{event.organizer_details.phone_1}}<br />
                    {{event.organizer_details.phone_2}}<br />
                    {{event.organizer_details.website}}<br />
                </b-card>
                <b-card>
                    <h4>
                        Tags
                        <b-badge style="float: right">
                            <i class="fa fa-tags"></i>
                        </b-badge>
                        
                    </h4>
                    <span v-for="t in event.tags">{{t}}<br /></span>
                </b-card>
                <router-view name="eventschedule"/>
                <router-view name="eventdescription"/>
                <router-view name="gueststatistics"/>
            </b-card-group>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "eventDetails",
    props: ["event_id"],
    data: () => {
        return {
            resources: {
                events: "/events"
            },
            event: {}
        };
    },
    methods: {
        fetchData(resource, options) {
            return axios
                .get(this.$store.getters.apiBase + this.$data.resources.events + "/" + this.$props["event_id"], {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                .then(response => {
                    this.$data.event = response.data;
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        name() {
            return this.event ? this.event.name : undefined;
        },
        address() {
            return this.event ? this.event.location ? this.event.location.address : {} : undefined;
        },
        schedule() {
            return this.event ? this.event.schedule : undefined;
        }
    },
    created() {
        this.fetchData();
    }
};
</script>